export default "/assets/images/pollen-video.mp4?83263f835043d8728c856d994d6847f3";